import { render, staticRenderFns } from "./TopLogo.vue?vue&type=template&id=30f3e4b0&"
import script from "./TopLogo.vue?vue&type=script&lang=js&"
export * from "./TopLogo.vue?vue&type=script&lang=js&"
import style0 from "./TopLogo.vue?vue&type=style&index=0&id=30f3e4b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports